import { render } from "./ManageDocRecipient.vue?vue&type=template&id=394d0df7&scoped=true"
import script from "./ManageDocRecipient.js?vue&type=script&lang=js"
export * from "./ManageDocRecipient.js?vue&type=script&lang=js"

import "./ManageDocRecipient.vue?vue&type=style&index=0&id=394d0df7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394d0df7"]])

export default __exports__